/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';

const GoogleLogin = ({
    socialId,
    scope,
    prompt,
    fetchBasicProfile,
    responseHandler,
    children,
    buttonText,
    ...rest
}) => {
    const [disabled, setDisabled] = React.useState(true);

    const clickHandler = () => {
        const auth2 = window.gapi.auth2.getAuthInstance();
        const options = {
            prompt,
            scope,
            fetchBasicProfile
        };
        auth2.signIn(options).then(googleUser => {
            const profile = googleUser.getBasicProfile();
            const data = {
                id: profile.getId(),
                name: profile.getName() || '',
                email: profile.getEmail(),
                access_token: googleUser.getAuthResponse().id_token
            };

            googleUser.disconnect();

            responseHandler(data);
        });
    };

    React.useEffect(() => {
        ((d, s, id, callback) => {
            let js;
            const gs = d.getElementsByTagName(s)[0];
            if (d.getElementById(id)) {
                setDisabled(false);
            } else {
                js = d.createElement(s);
                js.id = id;
                js.src = 'https://apis.google.com/js/platform.js';
                gs.parentNode.insertBefore(js, gs);
                js.onload = callback;
            }
        })(document, 'script', 'google-platform', () => {
            window.gapi.load(
                'auth2',
                () => {
                    setDisabled(false);
                    if (!window.gapi.auth2.getAuthInstance()) {
                        window.gapi.auth2.init({
                            client_id: socialId,
                            fetch_basic_profile: fetchBasicProfile,
                            scope
                        });
                    }
                },
                err => {
                    responseHandler(err);
                }
            );
        });
    }, [socialId, fetchBasicProfile, scope, responseHandler]);

    return (
        <button
            disabled={disabled || rest.disabled}
            type="button"
            onClick={clickHandler}
            {...rest}
        >
            {children}
            {buttonText}
        </button>
    );
};

GoogleLogin.propTypes = {
    socialId: PropTypes.string.isRequired,
    prompt: PropTypes.string,
    buttonText: PropTypes.string,
    responseHandler: PropTypes.func.isRequired,
    fetchBasicProfile: PropTypes.bool,
    scope: PropTypes.string,
    children: PropTypes.oneOfType([
        PropTypes.arrayOf(PropTypes.node),
        PropTypes.node
    ])
};

GoogleLogin.defaultProps = {
    fetchBasicProfile: false,
    scope: 'profile email',
    prompt: 'select_account',
    buttonText: 'Google Login',
    children: null
};

export default GoogleLogin;
